<template>
  <app-page-wrapper-grid class="user-profile__wrapper p-l-30 p-r-30">
    <div class="user-profile m-t-30 m-b-30">
      <h1 class="m-b-10">Account</h1>
      <div class="user-profile__section p-t-20 p-b-20 p-r-10 p-l-10 m-b-20">
        <app-link :route-to="{ name: ROUTE_NAMES.CHANGE_PASSWORD }" class="user-profile__title p-l-10 p-r-10"
          >Change password</app-link
        >
      </div>
      <div class="user-profile__section p-t-20 p-b-20 p-r-10 p-l-10 m-b-20">
        <app-link :route-to="{ name: ROUTE_NAMES.USER_INFO }" class="user-profile__title p-l-10 p-r-10"
          >Personal information</app-link
        >
      </div>
      <app-button text="Log Out" :aria-label="'Log Out'" style="width: 200px" :handler="submit" />
    </div>
  </app-page-wrapper-grid>
</template>

<script>
import { mapActions } from "vuex";
import { ROUTE_NAMES } from "@/utils";

export default {
  name: "UserProfile",
  data: function () {
    return {
      ROUTE_NAMES
    };
  },
  methods: {
    ...mapActions("user", ["logOutUser"]),
    submit() {
      this.logOutUser().then(() => {
        this.$router?.push({ name: ROUTE_NAMES.MENU });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .user-profile__section {
    background-color: $background-dark--2;
  }
}

.user-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 730px;
  font-size: 13px;

  &__wrapper {
    display: flex;
    align-items: center;
  }

  &__section {
    display: flex;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    background-color: $item-hover;
    border-radius: 5px;
  }

  &__title {
    font-size: 18px;
    font-family: $fontFamilyPrimary;
    font-weight: $font_regular;
    color: $secondary-color;
  }

  &__image {
    height: 60px;
  }

  @include respond-to-mobile {
    width: 100%;
  }
}
</style>
